import { useMutation } from "@apollo/client/react";
import { SEND_INVOICE_MESSAGE_TO_CLIENT } from "../../mutations/invoices/sendInvoiceMessageToClients";

export const useSendInvoiceMessageToClient = ({
  onCompleted,
  onError,
}: {
  onCompleted: (result?: any) => void;
  onError: (e?: any) => void;
}) => {
  const [sendInvoiceMessageToClient, { data, loading, error }] = useMutation(
    SEND_INVOICE_MESSAGE_TO_CLIENT,
    {
      onCompleted: onCompleted,
      onError: onError,
      refetchQueries: [],
      awaitRefetchQueries: true,
    },
  );

  return { sendInvoiceMessageToClient, data, loading, error };
};
